import { useNavigate, useParams } from 'react-router-dom';
import { Auth } from 'shared';
import {
  extractErrorMessageKeysFromHttpResponseException,
  localizeErrors,
} from 'shared/utils/response-error-handler';
import { SetPassword } from './SetPassword';
import i18n from 'i18next';
import { getPasswordValidationResult } from 'shared/utils/password-validator';
import LoginStyles from '../Login.module.scss';
import { LoginPageContainerForNonDeviceCodeForms } from '../LoginPageContainer';
import { useState } from 'react';
import { Links } from 'shared/infrastructure/Links';

export const SetPasswordPage: React.FC = () => {
  const { code, email } = useParams<{ code: string; email: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const navigate = useNavigate();

  const onSetupPasswordHandler = async (password: string, repeatPassword: string) => {
    if (!validate(password, repeatPassword)) {
      return;
    }
    setIsLoading(true);
    try {
      await Auth.authService().resetPassword(email, password, code);
      navigate(Links.PasswordHasBeenSet);
    } catch (e) {
      const errorMessage = extractErrorMessageKeysFromHttpResponseException(e);
      setErrors(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const fieldValuesChangedHandler = () => {
    setErrors([]);
  };
  const validate = (password: string, repeatPassword: string): boolean => {
    const validationErrors: string[] = [];

    if (password !== repeatPassword) {
      validationErrors.push(i18n.t('Errors_ConfirmPasswordMismatch'));
    }

    const passwordValidationError = getPasswordValidationResult(password);
    if (passwordValidationError) {
      validationErrors.push(passwordValidationError);
    }

    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return false;
    }
    return true;
  };

  return (
    <LoginPageContainerForNonDeviceCodeForms
      additionalClass={LoginStyles.forgotPasswordPage}
      isLoading={isLoading}
    >
      <SetPassword
        onSetupPassword={onSetupPasswordHandler}
        onFieldValueChange={fieldValuesChangedHandler}
        error={localizeErrors(errors)}
      />
    </LoginPageContainerForNonDeviceCodeForms>
  );
};
